module.exports = true;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/$.library.js
// module id = 102
// module chunks = 0